<template>
  <div class="searchfields-settings">

    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="mb-0">Search Index</h4>
          </div>

          <div v-if="!projectsLoaded" class="card-body text-center text-muted">
            <i class="fas fa-spinner fa-spin mr-1"></i> Loading projects…
          </div>
          <div v-else-if="reindexProjects.length === 0" class="card-body text-muted">
            No projects found.
          </div>
          <template v-else>
            <Table
              :data="reindexProjects"
              :columns="reindexColumns"
              :actions="reindexActions"
              :actionButton="reindexActionButton"
              :disableSearch="false"
              :search="{ placeholder: 'Search projects' }"
              @rowClicked="onProjectRowClicked"
            >
              <template v-slot:expanded-row="{ item }">
                <td colspan="5" class="p-0">
                  <div class="bg-dark p-2">
                    <div v-for="entry in item.log" :key="entry.message + entry.created_at" class="row mx-0">
                      <code class="col my-0" :class="entry.log_type !== 'info' ? 'text-danger' : 'text-white'" style="font-size: 0.75rem;">[{{ entry.log_type }}] {{ entry.created_at }} - {{ entry.message }}</code>
                    </div>
                  </div>
                </td>
              </template>
            </Table>
          </template>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h3>Searchfields</h3>
      </div>
      <div class="col-12">
        <h4>Congressresources</h4>
        <div class="form-check">
          <input id="overwriteCrsDefaults" v-model="CrsSearchfieldsOverwrite" type="checkbox" class="form-check-input" name="overwriteCrsDefaults" @change.prevent="handleCrsFields">
          <label class="form-check-label" for="overwriteCrsDefaults">overwrite default searchfields for congressresources</label>
        </div>
        <div v-if="CrsSearchfieldsOverwrite">
          <ul class="list-group">
            <li v-for="entry in searchfieldsByType('congressresource')" :key="entry.field" class="list-group-item">
              <div class="row">
                <div class="col-7 form-group">
                  <label>field</label>
                  <input v-model="entry.field" type="input" class="form-control">
                </div>
                <div class="col-4 form-group">
                  <label>boost</label>
                  <input v-model="entry.boost" type="input" class="form-control">
                </div>
                <div class="col-1">
                  <br>
                  <button class="btn btn-sm btn-danger" @click.prevent="deleteEntryByType(entry, 'congressresource')"><i class="fas fa-trash"></i></button>
                </div>
              </div>
            </li>
          </ul>
          <button class="btn btn-primary btn-sm" @click.prevent="addEntryByType('congressresource')"><i class="fas fa-plus"></i> add field</button>
        </div>
      </div>
      <div class="col-12">
        <hr>
      </div>
      <div class="col-12">
        <h4>Events</h4>
        <div class="form-check">
          <input id="overwriteEventDefaults" v-model="EventSearchfieldsOverwrite" type="checkbox" class="form-check-input" name="overwriteEventDefaults" @change="handleEventFields">
          <label class="form-check-label" for="overwriteEventDefaults">overwrite default searchfields for events</label>
        </div>
        <div v-if="EventSearchfieldsOverwrite">
          <ul class="list-group">
            <li v-for="entry in searchfieldsByType('event')" :key="entry.field" class="list-group-item">
              <div class="row">
                <div class="col-7 form-group">
                  <label>field</label>
                  <input v-model="entry.field" type="input" class="form-control">
                </div>
                <div class="col-4 form-group">
                  <label>boost</label>
                  <input v-model="entry.boost" type="input" class="form-control">
                </div>
                <div class="col-1">
                  <br>
                  <button class="btn btn-sm btn-danger" @click.prevent="deleteEntryByType(entry, 'event')"><i class="fas fa-trash"></i></button>
                </div>
              </div>
            </li>
          </ul>
          <button class="btn btn-primary btn-sm" @click.prevent="addEntryByType('event')"><i class="fas fa-plus"></i> add field</button>
        </div>
      </div>
      <div class="col-12">
        <hr>
      </div>
      <div class="col-12">
        <h4>Timelineitems</h4>
        <div class="form-check">
          <input id="overwriteTimelineDefaults" v-model="TimelineSearchfieldsOverwrite" type="checkbox" class="form-check-input" name="overwriteTimelineDefaults" @change="handleTimelineFields">
          <label class="form-check-label" for="overwriteTimelineDefaults">overwrite default searchfields for timelineitems</label>
        </div>
        <div v-if="TimelineSearchfieldsOverwrite">
          <ul class="list-group">
            <li v-for="entry in searchfieldsByType('timeline')" :key="entry.field" class="list-group-item">
              <div class="row">
                <div class="col-7 form-group">
                  <label>field</label>
                  <input v-model="entry.field" type="input" class="form-control">
                </div>
                <div class="col-4 form-group">
                  <label>boost</label>
                  <input v-model="entry.boost" type="input" class="form-control">
                </div>
                <div class="col-1">
                  <br>
                  <button class="btn btn-sm btn-danger" @click.prevent="deleteEntryByType(entry, 'timeline')"><i class="fas fa-trash"></i></button>
                </div>
              </div>
            </li>
          </ul>
          <button class="btn btn-primary btn-sm" @click.prevent="addEntryByType('timeline')"><i class="fas fa-plus"></i> add field</button>
        </div>
      </div>
      <div class="col-12">
        <hr>
      </div>
      <div class="col-12">
        <h4>Speakers</h4>
        <div class="form-check">
          <input id="overwriteSpeakerDefaults" v-model="SpeakerSearchfieldsOverwrite" type="checkbox" class="form-check-input" name="overwriteSpeakerDefaults" @change="handleSpeakerFields">
          <label class="form-check-label" for="overwriteSpeakerDefaults">overwrite default searchfields for speakers</label>
        </div>
        <div v-if="SpeakerSearchfieldsOverwrite">
          <ul class="list-group">
            <li v-for="entry in searchfieldsByType('speaker')" :key="entry.field" class="list-group-item">
              <div class="row">
                <div class="col-7 form-group">
                  <label>field</label>
                  <input v-model="entry.field" type="input" class="form-control">
                </div>
                <div class="col-4 form-group">
                  <label>boost</label>
                  <input v-model="entry.boost" type="input" class="form-control">
                </div>
                <div class="col-1">
                  <br>
                  <button class="btn btn-sm btn-danger" @click.prevent="deleteEntryByType(entry, 'speaker')"><i class="fas fa-trash"></i></button>
                </div>
              </div>
            </li>
          </ul>
          <button class="btn btn-primary btn-sm" @click.prevent="addEntryByType('speaker')"><i class="fas fa-plus"></i> add field</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'searchfields-settings',
  props: ['client'],
  data () {
    return {
      defaultSearchfields: null,
      CrsSearchfieldsOverwrite: false,
      EventSearchfieldsOverwrite: false,
      TimelineSearchfieldsOverwrite: false,
      SpeakerSearchfieldsOverwrite: false,
      projectsLoaded: false,
      projectsLoading: false,
      reindexAllLoading: false,
      reindexProjects: []
    }
  },
  computed: {
    reindexColumns () {
      return [
        { label: 'Project', property: 'title', searchable: true, sort: { enabled: true, default: true, order: 'ASC' } },
        {
          label: 'Status',
          badge: true,
          transform: (item) => item.process,
          sort: { enabled: true },
          badgeClass: (val) => ({
            'badge-danger': val === 'error',
            'badge-success': val === 'finished',
            'badge-info': val === 'running',
            'badge-secondary': !['error', 'finished', 'running'].includes(val)
          }),
          badgeIcon: (item) => !item.finished ? 'fas fa-spinner fa-spin mr-1' : null
        },
        {
          label: 'Last indexed',
          transform: (item) => item.lastIndexedAt ? this.formatRelativeDate(item.lastIndexedAt) : '—',
          sortTransform: (item) => item.lastIndexedAt || '',
          tooltip: (item) => item.lastIndexedAt ? this.formatAbsoluteDate(item.lastIndexedAt) : undefined,
          sort: { enabled: true }
        },
        {
          label: 'Auto-indexer',
          transform: (item) => item.autoIndexerLastRun ? this.formatRelativeDate(item.autoIndexerLastRun) : '—',
          sortTransform: (item) => item.autoIndexerLastRun || '',
          tooltip: (item) => item.autoIndexerLastRun ? this.formatAbsoluteDate(item.autoIndexerLastRun) : undefined,
          sort: { enabled: true }
        }
      ]
    },
    reindexActionButton () {
      return {
        icon: this.reindexAllLoading ? 'fas fa-sync-alt fa-spin' : 'fas fa-sync-alt',
        label: 'Re-index all projects',
        disabled: this.reindexAllLoading,
        action: () => this.reindexAll()
      }
    },
    reindexActions () {
      return [
        {
          buttonClass: 'btn-primary',
          title: (item) => item.finished ? 're-index project' : 'reindex already running',
          iconClass: (item) => item.reindexing ? 'fas fa-sync-alt fa-spin' : 'fas fa-sync-alt',
          disabled: (item) => !item.finished || item.reindexing,
          action: (item) => this.reindexSingleProject(item)
        },
        {
          expandToggle: true,
          buttonClass: 'btn-secondary',
          title: 'toggle log',
          iconExpanded: 'fas fa-chevron-up',
          iconCollapsed: 'fas fa-chevron-down',
          hidden: (item) => item.log.length === 0
        }
      ]
    },
    isLoading: {
      get () {
        return this.$store.getters.getLoadingState
      },
      set (val) {
        this.$store.commit('SET_LOADING_STATE', val)
      }
    },
    uploadUrl () {
      return this.$store.state.serverURI + '/api/v2/clients/' + this.client.data.id + '/giftcodes'
    },
    dropzoneOptions () {
      return {
        url: this.uploadUrl,
        maxFilesize: 1,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.token
        }
      }
    }
  },
  watch: {
    'client.data.id' (id) {
      if (id) {
        this.loadProjects()
      }
    },
    client (val) {
      if (val.searchfields && val.searchfields.congressresource.length > 0) {
        this.$set(this, 'CrsSearchfieldsOverwrite', true)
      }
      if (val.searchfields && val.searchfields.event.length > 0) {
        this.$set(this, 'EventSearchfieldsOverwrite', true)
      }
      if (val.searchfields && val.searchfields.timeline.length > 0) {
        this.$set(this, 'TimelineSearchfieldsOverwrite', true)
      }
      if (val.searchfields && val.searchfields.speaker.length > 0) {
        this.$set(this, 'SpeakerSearchfieldsOverwrite', true)
      }
    }
  },
  created () {
    this.getDefaultSearchfields()
    if (this.client && this.client.data && this.client.data.id) {
      this.loadProjects()
    }
  },
  beforeDestroy () {
    this.reindexProjects.forEach(p => clearTimeout(p.pollTimeout))
  },
  methods: {
    onProjectRowClicked (item) {
      this.$router.push('/clients/' + this.client.data.name + '/projects/' + item.id + '#api')
    },
    searchfieldsByType (type) {
      if (!this.client.searchfields || !this.client.searchfields[type]) {
        return []
      }
      return this.client.searchfields[type].length === 0 ? this.defaultSearchfields[type] : this.client.searchfields[type]
    },
    loadProjects () {
      if (this.projectsLoaded || this.projectsLoading) return
      if (!this.client || !this.client.data || !this.client.data.name) return
      this.projectsLoading = true
      this.$store.dispatch('getProjectsListForClient', this.client.data.name)
        .then(projects => {
          if (!projects) return
          this.reindexProjects = projects.map(p => ({
            id: p.id,
            name: p.name,
            title: p.title || p.name,
            finished: true,
            process: 'idle',
            log: [],
            autoIndexerLastRun: null,
            lastIndexedAt: null,
            pollTimeout: null,
            reindexing: false
          }))
          this.projectsLoaded = true
          this.reindexProjects.forEach(project => this.pollProjectStatus(project))
        })
        .catch(() => {
          this.$swal({ title: 'Error', text: 'Could not load project list.', icon: 'error' })
        })
        .finally(() => {
          this.projectsLoading = false
        })
    },
    pollProjectStatus (project) {
      this.$store.dispatch('searchV3IndexingProcessStatus', project.id)
        .then(response => {
          this.$set(project, 'finished', response.finished)
          this.$set(project, 'process', response.process)
          this.$set(project, 'log', response.log.slice(-5))
          if (response.auto_indexer_last_run) {
            this.$set(project, 'autoIndexerLastRun', response.auto_indexer_last_run)
          }
          if (response.last_indexed_at) {
            this.$set(project, 'lastIndexedAt', response.last_indexed_at)
          }
          const delay = response.finished ? 30000 : 5000
          project.pollTimeout = setTimeout(() => this.pollProjectStatus(project), delay)
        })
        .catch(() => {
          this.$set(project, 'process', 'error')
          project.pollTimeout = setTimeout(() => this.pollProjectStatus(project), 30000)
        })
    },
    reindexAll () {
      this.$swal({
        title: 're-index all Projects?',
        text: 'This will trigger a full re-index for every project of this client. Re-indexing can take a while.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Start re-index',
        confirmButtonColor: '#dd4b39',
        cancelButtonText: 'Cancel'
      }).then(result => {
        if (!result.value) return
        this.reindexAllLoading = true
        this.$store.dispatch('searchV3ReindexAllClientProjects', this.client.data.name)
          .then(response => {
            const queuedIds = new Set((response.data.projects || []).map(p => p.id))
            this.reindexProjects.forEach(project => {
              if (queuedIds.has(project.id)) {
                clearTimeout(project.pollTimeout)
                this.$set(project, 'finished', false)
                this.$set(project, 'process', 'running')
                project.pollTimeout = setTimeout(() => this.pollProjectStatus(project), 2000)
              }
            })
          })
          .catch(() => {
            this.$swal({ title: 'Error', text: 'Could not start re-index.', icon: 'error' })
          })
          .finally(() => {
            this.reindexAllLoading = false
          })
      })
    },
    reindexSingleProject (project) {
      this.$set(project, 'reindexing', true)
      this.$store.dispatch('searchV3ReindexResources', project.id)
        .then(() => {
          clearTimeout(project.pollTimeout)
          this.$set(project, 'finished', false)
          this.$set(project, 'process', 'running')
          project.pollTimeout = setTimeout(() => this.pollProjectStatus(project), 2000)
        })
        .catch(() => {
          this.$swal({ title: 'Error', text: 'Could not start re-index for ' + project.title + '.', icon: 'error' })
        })
        .finally(() => {
          this.$set(project, 'reindexing', false)
        })
    },
    normalizeDate (dateStr) {
      if (dateStr.includes('T')) return dateStr
      return dateStr.replace(' ', 'T') + 'Z'
    },
    formatAbsoluteDate (dateStr) {
      const normalized = this.normalizeDate(dateStr)
      const pad = n => String(n).padStart(2, '0')
      try {
        // eslint-disable-next-line no-undef
        if (typeof Temporal !== 'undefined') {
          // eslint-disable-next-line no-undef
          const zdt = Temporal.Instant.from(normalized).toZonedDateTimeISO(Intl.DateTimeFormat().resolvedOptions().timeZone)
          return `${zdt.year}-${pad(zdt.month)}-${pad(zdt.day)}, ${pad(zdt.hour)}:${pad(zdt.minute)}:${pad(zdt.second)}`
        }
      } catch (e) {}
      const d = new Date(normalized)
      if (isNaN(d)) return dateStr
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}, ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    formatRelativeDate (dateStr) {
      const normalized = this.normalizeDate(dateStr)
      try {
        // eslint-disable-next-line no-undef
        if (typeof Temporal !== 'undefined') {
          // eslint-disable-next-line no-undef
          const diffMs = Number(Temporal.Now.instant().epochMilliseconds - Temporal.Instant.from(normalized).epochMilliseconds)
          return this.relativeFromMs(diffMs)
        }
      } catch (e) {}
      const d = new Date(normalized)
      if (isNaN(d)) return dateStr
      return this.relativeFromMs(Date.now() - d.getTime())
    },
    relativeFromMs (diffMs) {
      const abs = Math.abs(diffMs)
      const suffix = diffMs < 0 ? 'from now' : 'ago'
      if (abs < 60000) return 'just now'
      if (abs < 3600000) return `${Math.floor(abs / 60000)} min ${suffix}`
      if (abs < 86400000) return `${Math.floor(abs / 3600000)} h ${suffix}`
      if (abs < 2592000000) return `${Math.floor(abs / 86400000)} days ${suffix}`
      if (abs < 31536000000) return `${Math.floor(abs / 2592000000)} months ${suffix}`
      return `${Math.floor(abs / 31536000000)} years ${suffix}`
    },
    getDefaultSearchfields () {
      this.isLoading = true
      this.$store.dispatch('getDefaultSearchfields')
        .then(response => {
          this.defaultSearchfields = response.searchfields
          this.isLoading = false
        })
    },
    addEntryByType (type) {
      this.client.searchfields[type].push({ field: '', boost: '', type: type })
    },
    deleteEntryByType (entry, type) {
      this.client.searchfields[type].splice(this.client.searchfields[type].indexOf(entry), 1)
    },
    handleCrsFields (e) {
      if (!e.target.checked && this.client.searchfields.congressresource !== this.defaultSearchfields.congressresource) {
        this
          .$swal({
            title: 'Are you really sure?',
            text: 'disabling overwrite will delete the defined overwrites',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'disable',
            confirmButtonColor: '#dd4b39',
            cancelButtonText: 'Cancel'
          })
          .then(result => {
            if (result.value) {
              this.client.searchfields.congressresource = []
            } else {
              this.$set(this, 'CrsSearchfieldsOverwrite', true)
            }
          })
      } else if (!e.target.checked && this.client.searchfields.congressresource === this.defaultSearchfields.congressresource) {
        this.client.searchfields.congressresource = []
      }
      if (e.target.checked && this.client.searchfields.congressresource.length === 0) {
        this.client.searchfields.congressresource = JSON.parse(JSON.stringify(this.defaultSearchfields.congressresource))
      }
    },
    handleEventFields (e) {
      if (!e.target.checked && this.client.searchfields.event !== this.defaultSearchfields.event) {
        this
          .$swal({
            title: 'Are you really sure?',
            text: 'disabling overwrite will delete the defined overwrites',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'disable',
            confirmButtonColor: '#dd4b39',
            cancelButtonText: 'Cancel'
          })
          .then(result => {
            if (result.value) {
              this.client.searchfields.event = []
            } else {
              this.$set(this, 'EventSearchfieldsOverwrite', true)
            }
          })
      } else if (!e.target.checked && this.client.searchfields.event === this.defaultSearchfields.event) {
        this.client.searchfields.event = []
      }
      if (e.target.checked && this.client.searchfields.event.length === 0) {
        this.client.searchfields.event = JSON.parse(JSON.stringify(this.defaultSearchfields.event))
      }
    },
    handleTimelineFields (e) {
      if (!e.target.checked && this.client.searchfields.timeline !== this.defaultSearchfields.timeline) {
        this
          .$swal({
            title: 'Are you really sure?',
            text: 'disabling overwrite will delete the defined overwrites',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'disable',
            confirmButtonColor: '#dd4b39',
            cancelButtonText: 'Cancel'
          })
          .then(result => {
            if (result.value) {
              this.client.searchfields.timeline = []
            } else {
              this.$set(this, 'TimelineSearchfieldsOverwrite', true)
            }
          })
      } else if (!e.target.checked && this.client.searchfields.timeline === this.defaultSearchfields.timeline) {
        this.client.searchfields.timeline = []
      }
      if (e.target.checked && this.client.searchfields.timeline.length === 0) {
        this.client.searchfields.timeline = JSON.parse(JSON.stringify(this.defaultSearchfields.timeline))
      }
    },
    handleSpeakerFields (e) {
      if (!e.target.checked && this.client.searchfields.speaker !== this.defaultSearchfields.speaker) {
        this
          .$swal({
            title: 'Are you really sure?',
            text: 'disabling overwrite will delete the defined overwrites',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'disable',
            confirmButtonColor: '#dd4b39',
            cancelButtonText: 'Cancel'
          })
          .then(result => {
            if (result.value) {
              this.client.searchfields.speaker = []
            } else {
              this.$set(this, 'SpeakerSearchfieldsOverwrite', true)
            }
          })
      } else if (!e.target.checked && this.client.searchfields.speaker === this.defaultSearchfields.speaker) {
        this.client.searchfields.speaker = []
      }
      if (e.target.checked && this.client.searchfields.speaker.length === 0) {
        this.client.searchfields.speaker = JSON.parse(JSON.stringify(this.defaultSearchfields.speaker))
      }
    }
  }
}
</script>
